import { deepExtract } from 'helpers/deep';

export const isLoggedIn = state => !!state.user.loggedIn;

export const memberStatus = state =>
  state.user.loggedIn && state.entities.userProfile.data.default
    ? state.entities.userProfile.data.default.membership.status
    : '';

export const userHasCpCorporateEmail = state =>
  deepExtract('default.email', state.entities.userProfile.data, '').indexOf('@classpass.com') !== -1;

export const userId = state =>
  state.user.loggedIn && state.entities.userProfile.data.default ? state.entities.userProfile.data.default.id : null;

export const viewingNextCycle = state => state.user.viewingNextCycle;
export const scheduleContext = state => state.user.scheduleContext;
